import {
  EvidenceGrade,
  ProvisioningType,
  SuggestionConfidence,
  TenderPhaseType,
} from '@frontend/shared-api';

export const SUGGESTION_KEY_PREFIX = 'provider.templates.suggestions';

export enum SuggestionListFilter {
  ALL = 'ALL',
  OPEN_SUGGESTION = 'OPEN_SUGGESTION',
  CLARIFICATION = 'CLARIFICATION',
  UNANSWERED = 'UNANSWERED',
  REVIEW_REQUIRED = 'REVIEW_REQUIRED',
}

export type SuggestionTagSeverity = 'success' | 'info' | 'warn' | 'secondary';

export const CONFIDENCE_SEVERITY: Record<SuggestionConfidence, SuggestionTagSeverity> = {
  [SuggestionConfidence.HIGH]: 'success',
  [SuggestionConfidence.MEDIUM]: 'info',
  [SuggestionConfidence.LOW]: 'warn',
};

export const EVIDENCE_GRADE_SEVERITY: Record<EvidenceGrade, SuggestionTagSeverity> = {
  [EvidenceGrade.STRONG]: 'success',
  [EvidenceGrade.MODERATE]: 'info',
  [EvidenceGrade.WEAK]: 'secondary',
};

export interface SuggestionContext {
  toolId: number;
  phase: TenderPhaseType;
}

export interface PersistedAttributeValue {
  directusId: string;
  score: number;
  capabilityLevel?: number;
  provisioningType?: ProvisioningType;
}

export interface OverrideValue {
  score: number;
  capabilityLevel?: number;
  provisioningType?: ProvisioningType;
  comment?: string;
  reason?: string;
}

export interface BulkAcceptResult {
  accepted: number;
  skipped: number;
}
